import { SHOW_SLIDE_PANEL, HIDE_SLIDE_PANEL } from './slidePanelActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    isSlidePanelOpen: false,
})

// TODO : this should be a boolean
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_SLIDE_PANEL:
            return state.set('isSlidePanelOpen', true)
        case HIDE_SLIDE_PANEL:
            return state.set('isSlidePanelOpen', false)
        default:
            return state
    }
}
